import {useState,useEffect} from 'react'; 
import  Bredcrum  from '../../components/bredcrum';
import { Tag } from 'primereact/tag';
import {Tablescom} from '../../components/tablescomp';
import {userservices} from '../../services/userServices';
import {Titlebar,Searchbox} from  '../../components/fieldsComp';
const Shipmenttracking = () =>{

    const [users,setUsers] = useState([]);
    const [userloaded,setUserloaded] = useState(true);


 useEffect(()=>{
    getusers();
 },[]); 

  const [colDefs, setColDefs] = useState([
    { headerName: "SR NO",field: "id" },
    { headerName: "Product Name",field: "name" },
    { headerName: "Master SKU Code",field: "isactive",cellRenderer: (params) => {
        return (
            <Tag severity="success" value={params.getValue()} rounded></Tag>
         
        );
      } },
    { headerName: "Components",field: "name" },
    { headerName: "Component SKU Codes",field: "name" },
    { headerName: "Supplier",field: "name" },
    { headerName: "Cost",field: "name" },
    { headerName: "Stock Level",field: "name" },
    { headerName: "Freight Charges",field: "name" },
    { headerName: "Unit of Measurement",field: "name" },
    { headerName: "Superdrug SKU Code",field: "name" },
    { headerName: "Notes",field: "name" },
    
    
    
    { headerName: "Action",
    cellRenderer: (params) => {
      return (
        <>
             <button class="btn  btn-sm btn-white custom-btn-color2 "><i class="icon icon-note icon-style color-white"></i></button>
             {/* <button class="btn btn-danger btn-sm btn-white btn-border-none"><i class="icon icon-trash txt-error icon-style"></i></button>  */}
        </>
       
      );
    } }
  ]);


  const getusers  = ()=> {
        setUserloaded(true);
        userservices.getusers().then((response)=>{
            if(response.status == 200){
              console.log(response.data.data);
                setUsers(response.data.data);
                setUserloaded(false);
            }else{
                setUsers([]);
                setUserloaded(false);
            }  
        }).catch((error)=>{
            setUsers([]);
            setUserloaded(false);
        }); 
  } 



    return(
       <>
          <Bredcrum title={'Product'} divider={false}/>
          <div class="row">
              <div className='col-md-12 mb-4 mt-4'>
                 <div className='flex-box flex-between'>
                      <button className='btn btn-primary rounded-pill custom-btn-color custom-btn-br-color custom-btn-style'>Location</button> 
                      <Searchbox/>
                  </div> 
              </div> 
             
              
              <Titlebar text={'Shipment Tracking'}/>
              <div className="col-md-12 mt-3">
                  <div className='card'>
                    <div className='card-body card-body-style'>
                     <Tablescom rowdata={users} coldefs={colDefs} isloaded={userloaded}/>
                     </div>
                 </div>
              </div>   
          </div>
       </>
    );   
 }
 export default Shipmenttracking;